// Here, all the global application level config will be there.

export const appConfig = {};

export const snackbarUIConfig = {
  maxSnack: 4,
  autoHideDuration: 4000,
};
